import React, {FC, ReactNode} from 'react';
import BaseButton from '../Button';

interface IMixWeekButton {
    children: ReactNode
}

const MixWeekButton:FC<IMixWeekButton> = ({children, }) => {
    return (
        <BaseButton
            onClick={() => {}}
            withBorderRadius
            isMixCard
            isSizeL
        >
            {children}
        </BaseButton>
    )
};

export default MixWeekButton;
